import BasicAPI, {Warning} from "@/types/basic";

export class GetAccessInformationResults extends BasicAPI {
    constructor(params) {
        super();
        /**
         * @type {Number}
         */
        this.canaddinstance = params.canaddinstance
        /**
         * @type {Number}
         */
        this.canviewreport = params.canviewreport
        /**
         * @type {Number}
         */
        this.canskipview = params.canskipview
        /**
         * @type {Number}
         */
        this.cansavetrack = params.cansavetrack
        /**
         * @type {Number}
         */
        this.canviewscores = params.canviewscores
        /**
         * @type {Number}
         */
        this.candeleteresponses = params.candeleteresponses
        /**
         * @type {Number}
         */
        this.candeleteownresponses = params.candeleteownresponses

        if (params.warnings) {
            /**
             * @type {Array<Warning>}
             */
            this.warnings = params.warnings.map(warning => new Warning(warning));
        }
    }

    /**
     * Валидация полей
     * @param expect {Expect<{}>}
     * @param test {TestType<PlaywrightTestArgs & PlaywrightTestOptions, PlaywrightWorkerArgs & PlaywrightWorkerOptions>}
     */
    validate({expect, test}) {
        if (!this.success) {
            expect(this.warnings).toBeTruthy();

            for (let warning of this.warnings) {
                test.step(`Проверка предупреждения ${warning.warningCode}`, () => {
                    warning.validate({expect})
                })
            }
        }
    }
}
